import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {url: String, domElementToUpdate: String}
  static targets = ["timeSheetCode", "dayCareType", "loader"]

  connect() {
    this.abortController = null
  }

  disconnect() {
    this.abortCurrentRequest()
  }

  async filter() {
    this.abortCurrentRequest()
    this.abortController = new AbortController()

    const timeSheetCodeId = this.timeSheetCodeTarget.value
    const dayCareType = this.dayCareTypeTarget.value
    const currentAbortController = this.abortController

    this.showLoader()

    const params = new URLSearchParams({
      dom_element_to_update: this.domElementToUpdateValue,
      time_sheet_code_id: timeSheetCodeId,
      day_care_type: dayCareType,
    })

    try {
      const response = await fetch(`${this.urlValue}?${params}`, {
        headers: {Accept: "text/html"},
        signal: currentAbortController.signal,
      })

      if (!response.ok) {
        throw new Error(`Personnel days filter request failed with status ${response.status}`)
      }

      this.element.innerHTML = await response.text()
      this.reinitializeDom()
    } catch (error) {
      if (error.name === "AbortError") {
        return
      }

      if (window.Sentry) {
        window.Sentry.captureException(error)
      }
    } finally {
      if (this.abortController === currentAbortController) {
        this.abortController = null
        this.hideLoader()
      }
    }
  }

  clearFilters() {
    this.timeSheetCodeTarget.value = ""
    this.dayCareTypeTarget.value = ""
    this.filter()
  }

  abortCurrentRequest() {
    if (this.abortController) {
      this.abortController.abort()
    }
  }

  showLoader() {
    this.loaderTarget.classList.remove("hidden")
  }

  hideLoader() {
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add("hidden")
    }
  }

  reinitializeDom() {
    window.reinitializeDomElements()
    window.afterAjaxReinitialize()
  }
}
